import $ from 'jquery'

async function init () {
  $('.leasingtest-module').each(async function () {
    await import(/* webpackChunkName: "slick" */ 'slick-carousel/slick/slick')
    const $this = $(this),
      $sliderWrapper = $this.find('.leasingtest-slider-wrapper'),
      $progress = $this.find('.question-slider')

    $sliderWrapper.on('afterChange', function (event, slick, currentSlide) {
      $this.find('.lens-text-inner-wrapper').removeClass('intro-small')
      $this.find('.lens-text-inner-wrapper').removeClass('intro-big')

      let progress = $progress.attr('data-progress')
      if ((slick.$slides.length - 1) == currentSlide + slick.options.slidesToScroll) {
        $progress.attr('data-progress', 'result')
      }
      if (progress == 'progress') {
        $this.find('.lens-intro').css('display', 'none')
        $this.find('.lens-question-text').css('display', 'block')
        $this.find('.lens-number').css('display', 'block')
        $this.find('.lens-number').html((slick.currentSlide) + '/' + (slick.slideCount - 2))
      }
    })

    $sliderWrapper.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      cssEase: 'linear',
      draggable: false,
      swipe: false,
      adaptiveHeight: true
    })

    if (window.innerWidth < 768) {
      if ($this.find('.lens-intro').innerHeight() > 22) {
        $this.find('.lens-text-inner-wrapper').addClass('intro-big')
      } else if ($this.find('.lens-intro').innerHeight() < 36) {
        $this.find('.lens-text-inner-wrapper').addClass('intro-small')
      }
    }

    clickNext($this)
  })
}

let localStorageData = ''

function clickNext (el) {
  const $sliderWrapper = el.find('.leasingtest-slider-wrapper'),
    $progress = el.find('.question-slider')

  let buttons = el.find('[data-question-slider]'),
    status = 0

  buttons.each(function () {
    $(this).on('click', function () {

      if ($(this).data('answer')) {
        let answer = $(this).data('answer'),
          question = $('.slick-current.slick-active').find('.question-slide-item.question-box p').text()

        localStorageData = localStorageData + question + answer + '; '
        localStorage.leasingtest = JSON.stringify(localStorageData)
      }

      let progress = $progress.attr('data-progress')

      if (progress == 'start') {
        el.find('.intro-button').toggle('fast', function () {
          el.find('.question-buttons').toggle('slow')
        })
        $progress.attr('data-progress', 'progress')
      }

      if ($(this).attr('data-question-slider') == 0) {
        status++
      }

      if (progress == 'result') {
        let answerIdx = 0
        if (status <= 1) {
          answerIdx = 1
        }
        el.find('.lens-question-text').css('display', 'none')
        el.find('.lens-number').css('display', 'none')
        el.find('.lens-text-inner-wrapper').addClass('small-text')
        el.find('.lens-result').css('display', 'block')
        el.find('.item_' + answerIdx).css('display', 'block')
        el.find('.question-box p').css('visibility', 'hidden')
        el.find('.answer_' + answerIdx).css('display', 'flex')
        el.find('.question-buttons').toggle('fast', function () {
          el.find('.answer-buttons').toggle('slow')
        })
        localStorageData = localStorageData + 'Results:' + $($(`.item_${answerIdx}`)[0]).find('.result-text').find('>:first-child').text()
        localStorage.leasingtest = JSON.stringify(localStorageData)
      }
      $sliderWrapper.slick('slickNext')
    })
  })
}

export default {
  init
}
